/* eslint-disable no-undef */
Sofatutor.Classes.VideosCarousel = class {
  defaults = {
    selectors: {
      videosCarousel: '.videos-carousel'
    }
  };

  constructor(container, firstBreakpointInDesktop, maxNumberOfCards) {
    this.firstBreakpointInDesktop = firstBreakpointInDesktop;
    this.$carousel = $(this.defaults.selectors.videosCarousel, container);
    this.maxNumberOfCards = maxNumberOfCards;
    this.createSlickCarousel();

    this.numberOfSlides = this.$carousel.slick('getSlick').slideCount;

    this.goToCurrentIndex();
  }

  createSlickCarousel() {
    const responsiveProperty = [
      {
        breakpoint: 640,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          variableWidth: true,
          arrows: false
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      },
      {
        breakpoint: 821,
        settings: {
          slidesToShow: 4,
          arrows: false
        }
      }
    ];
    this.$carousel.slick({
      slidesToShow: this.maxNumberOfCards,
      slidesToScroll: 1,
      infinite: false,
      swipeToSlide: true,
      waitForAnimate: Sofatutor.env == 'test' ? false : true,
      arrows: true,
      prevArrow:
        '<button class="videos-carousel__previous-arrow slick-prev" aria-label="Zurück"><i class="icon icon--arrow-simple icon--rotate-left icon--large"></i></button>',
      nextArrow:
        '<button class="videos-carousel__next-arrow slick-next" aria-label="Weiter"><i class="icon icon--arrow-simple icon--large"></i></button>',
      responsive: responsiveProperty
    });
  }

  goToCurrentIndex() {
    if (!this.$carousel.data('current-video-index')) return;

    let indexToGoTo = this.$carousel.data('current-video-index');
    const numberOfActiveSlides = $('.slick-active', this.$carousel).length;

    if (numberOfActiveSlides != 0) {
      if (this.numberOfSlides > numberOfActiveSlides) {
        const maxClicks = this.numberOfSlides - numberOfActiveSlides;
        if (indexToGoTo > maxClicks) {
          indexToGoTo = maxClicks;
        }
      }
    }

    this.$carousel.slick('slickGoTo', indexToGoTo);
  }

  reInit() {
    this.$carousel.slick('reinit');
  }
};

if ($('.videos-prime-list .videos-carousel').length) {
  Sofatutor.features.primeListCarousel = new Sofatutor.Classes.VideosCarousel(
    '.videos-prime-list',
    959,
    5
  );
  $(window).trigger('resize');
}
if ($('.videos-bonus-list .videos-carousel').length) {
  Sofatutor.features.bonusListCarousel = new Sofatutor.Classes.VideosCarousel(
    '.videos-bonus-list',
    959,
    5
  );
  $(window).trigger('resize');
}
